<template>
  <div class="relative w-full md:w-fit pb-4">
    <form role="search">
      <InputText
        :name
        :placeholder
        label="Sök"
        type="search"
        :aria-label="placeholder"
        :input-id="`productlist-search-input-${name}`"
        icon="search"
        width="w-full md:w-[43rem]"
        :specific-left-offset-rem-for-text="inputLeftOffsetInRem"
        clearable
        :input-debounce-ms="400"
        autocomplete
        @input="onInput"
        @cleared="() => (filterStore.searchString = '')"
      />
      <p hidden data-testid="numberOfhitsString">{{ nrHitsString }}</p>
      <p
        lang="sv"
        class="absolute left-14 top-[29px] px-4 text-text-on-highlight rounded-xs heading-xxs bg-surface-secondary"
        aria-live="polite"
        aria-atomic="true"
      >
        <span aria-hidden="true">{{ nrHitsString }}</span>
        <span class="sr-only">{{ debouncedScreenReaderResultsString }}</span>
      </p>
    </form>
  </div>
</template>
<script setup lang="ts">
const filterStore = useFilterStore();

const onInput = (e: { target: { value?: string } }) => {
  const value = e.target.value;
  filterStore.searchString = value ? value.trim() : '';
};

const nrHitsString = computed(() => {
  if (filterStore.searchString) {
    return filterStore.numberOfFilteredProducts + ' st';
  } else {
    return '';
  }
});

const debouncedScreenReaderResultsString = ref('');
const screenReaderResultsString = computed(() => {
  const nrResults = filterStore.searchString
    ? filterStore.numberOfFilteredProducts
    : null;

  return nrResults !== null
    ? `${nrResults} stycken resultat på din sökning visas nedan`
    : `Resultat visas nedan`;
});
const debounceFnTest = useDebounceFn(
  () => screenReaderResultsString.value,
  1000,
);

watch(
  screenReaderResultsString,
  async () => {
    debouncedScreenReaderResultsString.value = await debounceFnTest();
  },
  { immediate: true },
);

const inputLeftOffsetInRem = computed(() =>
  nrHitsString.value.length ? nrHitsString.value.length + 2 : undefined,
);

withDefaults(
  defineProps<{
    name: string;
    placeholder?: string;
  }>(),
  {
    placeholder: '',
  },
);
</script>
